import EventEmitter2 from 'eventemitter2';
export default class Search extends EventEmitter2 {
    /**
     * Create a new Search instance, and override defaults
     *
     * @param options
     * @property {string} options.type - Search restriction. Use 'article', 'page', 'product', or ''
     * @property {string} options.view - Search template suffix. Specify different templates as needed
     */
    constructor(options = {}) {
        super();
        this.searchType = options.type || '';
        this.view = options.view || 'json';
        this.inProgress = false;
        this.xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
        this._xhrLoad = this._xhrLoad.bind(this);
        this._xhrError = this._xhrError.bind(this);
        this._xhrAbort = this._xhrAbort.bind(this);
        this._bindEvents();
    }
    _bindEvents() {
        this.xhr.addEventListener('load', this._xhrLoad);
        this.xhr.addEventListener('error', this._xhrError);
        this.xhr.addEventListener('abort', this._xhrAbort);
    }
    /**
     * XHR was successfull
     *
     * @description XHR completed successfully
     * @param {object} event
     * @fires Search#complete
     * @private
     */
    _xhrLoad(event) {
        let response = {};
        const { readyState, status } = event.target;
        try {
            if (readyState > 3 && status === 200) {
                response = event.target.responseText;
                const jsonData = JSON.parse(response);
                this.emit('complete', jsonData);
            }
            else {
                const message = `Invalid readyState: ${readyState}, or status: ${status}.`;
                this._xhrError(event, message);
                return;
            }
        }
        catch (error) {
            this._xhrError(event, 'Invalid JSON', error);
            return;
        }
        this.inProgress = false;
    }
    /**
     * XHR contains an error
     *
     * @description XHR has contained an error, and was unable to complete
     * @param {object} event
     * @param {object|string} message
     * @param {object} error
     * @fires Search#error
     * @private
     */
    _xhrError(event, message = null, error = null) {
        this.inProgress = false;
        this.emit('error', {
            event,
            message,
            error,
        });
    }
    /**
     * XHR has been aborted
     *
     * @description This event only fires if there is an active XHR request that has been terminated
     * @fires Search#aborted
     * @private
     */
    _xhrAbort() {
        this.emit('aborted');
    }
    /**
     * Perform the search
     *
     * @param {string} term - Search term(s)
     * @fires Search#initialized
     * @fires Search#cancelled
     */
    execute(term) {
        this.emit('initialized', {
            term,
        });
        if (this.inProgress) {
            this.emit('cancelled');
            this.xhr.abort();
        }
        this.inProgress = true;
        const url = globalThis.Theme.routes.search_url;
        const params = {
            q: term,
            type: this.searchType,
            view: this.view,
        };
        const searchParams = Object.keys(params)
            .map((key) => {
            const value = params[key];
            return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        })
            .join('&');
        this.xhr.open('get', `${url}?${searchParams}`);
        this.xhr.setRequestHeader('Accept', 'application/json');
        this.xhr.send();
    }
}
